export default {
  //产品
  //导航跳转
  lall_product: [
    "全部产品",
    "畅销产品",
    "新品上市",
    "清洁系列",
    "保湿滋养系列",
    "活颜精华系列",
    "舒敏修护系列",
    "紧致提升雕塑系列",
    "铂金酵素系列",
    "光皙焕颜系列",
    "隔离防护系列"
  ],
  product_content: [
    {
      series_id: 1,
      series_name: "畅销产品",
      isnull: "a",
      product_list: [
        //1#柔和卸妆乳
        {
          product_id: 1,
          product_img: "./static/LRimg/productsAll/1.jpg",
          product_title: "清洁系列 ",
          product_mj: "1# 柔和卸妆乳",
          product_price: "￥480.00",
          product_specifications: "150ml",
          mj_school_poster: "./static/YTimg/videohead/1.jpg",
          mj_school_video: "http://video.anab.com.cn/2.mp4",
          pro_mj_detail: [
            {
              mj_school_head: "./static/YTimg/detailsV/1.jpg",
              product_mj: "1# 柔和卸妆乳",
              product_title: "清洁系列 ",
              pro_mj_Summary:
                "肌肤的吸尘器，可直接冲洗不需要乳化的清爽型卸妆凝乳。 ",
              product_price: "￥480.00",
              product_specifications: "150ml",
              product_img: "./static/LRimg/productsAll/1.jpg",
              product_img2: "./static/LRimg/productsAll2/anab1.jpg",
              product_effect:
                "非乳化型卸妆凝乳，丰富添加P.C.A植物精华, 卸妆同时为肌肤补充营养，保持肌肤滋润及通透洁净。",
              product_explain:
                "干手干脸均匀覆盖脸部，轻柔按摩30秒后，用温毛巾擦拭干净。",
              collocation_suggestion: [
                {
                  series_id: 3,
                  id: 2,
                  product_id: 2,
                  suggestion_img: "./static/LRimg/productsAll/11.jpg",
                  suggestion_title: "清洁系列 ",
                  suggestion_mj: "7# 水溶性凝胶",
                  suggestion_price: "￥480.00",
                  suggestion_specifications: "260g"
                },
                {
                  series_id: 4,
                  id: 3,
                  product_id: 3,
                  suggestion_img: "./static/LRimg/productsAll/3.jpg",
                  suggestion_title: "保湿滋养系列 ",
                  suggestion_mj: "4# 保湿整肤液",
                  suggestion_price: "￥530.00",
                  suggestion_specifications: "100ml"
                },
                {
                  series_id: 10,
                  id: 0,
                  product_id: 4,
                  suggestion_img: "./static/LRimg/productsAll/1.jpg",
                  suggestion_title: "隔离防护系列 ",
                  suggestion_mj: "6# 隔离精华乳",
                  suggestion_price: "￥480.00",
                  suggestion_specifications: "50g"
                },
                {
                  series_id: 7,
                  id: 2,
                  product_id: 15,
                  suggestion_img: "./static/LRimg/productsAll/12.jpg",
                  suggestion_title: "紧致提升雕塑系列 ",
                  suggestion_mj: "8-1# 凝时精华眼霜",
                  suggestion_price: "￥680.00",
                  suggestion_specifications: "15ml"
                }
              ]
            }
          ]
        },
        //4#保湿整肤液
        {
          product_id: 5,
          product_img: "./static/LRimg/productsAll/7.jpg",
          product_title: "保湿滋养系列 ",
          product_mj: "4# 保湿整肤液",
          product_price: "￥530.00",
          product_specifications: "100ml",
          mj_school_poster: "./static/YTimg/videohead/4.jpg",
          mj_school_video: "http://video.anab.com.cn/8.mp4",
          pro_mj_detail: [
            {
              mj_school_head: "./static/YTimg/detailsV/4.jpg",
              product_mj: "4# 保湿整肤液",
              product_title: "保湿滋养系列 ",
              pro_mj_Summary:
                "浓密型态的保湿美容整肤液，充分浸润肌肤，使肌肤像喝饱了水一般的呈现饱满光泽。 ",
              product_price: "￥530.00",
              product_specifications: "100ml",
              product_img: "./static/LRimg/productsAll/7.jpg",
              product_img2: "./static/LRimg/productsAll2/anab4.jpg",
              product_effect:
                "质地盈润，分层保湿，富含P.C.A植物提取精华，有效平衡肌肤状态，改善肌肤干荒暗哑，深度保湿。",
              product_explain:
                "按压2～3泵，轻拍至肌肤吸收；化妆棉浸透后湿敷密集补水；与纯净水调稀后可做化妆水使用。",
              collocation_suggestion: [
                {
                  series_id: 4,
                  id: 1,
                  product_id: 7,
                  suggestion_img: "./static/LRimg/productsAll/8.jpg",
                  suggestion_title: "保湿滋养系列 ",
                  suggestion_mj: "5# 活力保湿霜",
                  suggestion_price: "￥530.00",
                  suggestion_specifications: "50ml"
                },
                {
                  series_id: 7,
                  id: 1,
                  product_id: 14,
                  suggestion_img: "./static/LRimg/productsAll/9.jpg",
                  suggestion_title: "紧致提升雕塑系列 ",
                  suggestion_mj: "5-1# 凝珠精华霜 ( 小雕塑霜 )",
                  suggestion_price: "￥738.00",
                  suggestion_specifications: "30ml"
                },
                {
                  series_id: 8,
                  id: 0,
                  product_id: 17,
                  suggestion_img: "./static/LRimg/productsAll/17.jpg",
                  suggestion_title: "铂金酵素系列 ",
                  suggestion_mj: "美肌精",
                  suggestion_price: "￥2180.00",
                  suggestion_specifications: "120ml"
                },
                {
                  series_id: 10,
                  id: 0,
                  product_id: 19,
                  suggestion_img: "./static/LRimg/productsAll/10.jpg",
                  suggestion_title: "隔离防护系列 ",
                  suggestion_mj: "6# 隔离精华乳",
                  suggestion_price: "￥480.00",
                  suggestion_specifications: "50g"
                }
              ]
            }
          ]
        },
        //5#活力保湿霜
        {
          product_id: 7,
          product_img: "./static/LRimg/productsAll/8.jpg",
          product_title: "保湿滋养系列 ",
          product_mj: "5# 活力保湿霜",
          product_price: "￥530.00",
          product_specifications: "50ml",
          mj_school_poster: "./static/YTimg/videohead/5.jpg",
          mj_school_video: "http://video.anab.com.cn/9.mp4",
          pro_mj_detail: [
            {
              mj_school_head: "./static/YTimg/detailsV/5.jpg",
              product_mj: "5# 活力保湿霜",
              product_title: "保湿滋养系列 ",
              pro_mj_Summary:
                "如同保护膜一般，能够在肌肤表层起到长时间锁水滋润效果。 ",
              product_price: "￥530.00",
              product_specifications: "50ml",
              product_img: "./static/LRimg/productsAll/8.jpg",
              product_img2: "./static/LRimg/productsAll2/anab5.jpg",
              product_effect:
                "添加保湿效果的角鲨烷、维生素E及植物提取精华，完整提供肌肤内层所需要的营养，同时在肌肤外层形成滋润的保护膜，长时间保持肌肤的状态。",
              product_explain: "按压1～2泵均匀涂抹于面部，兼具日晚霜功效。",
              collocation_suggestion: [
                {
                  series_id: 4,
                  id: 3,
                  product_id: 5,
                  suggestion_img: "./static/LRimg/productsAll/7.jpg",
                  suggestion_title: "保湿滋养系列 ",
                  suggestion_mj: "4# 保湿整肤液",
                  suggestion_price: "￥530.00",
                  suggestion_specifications: "100ml"
                },
                {
                  series_id: 7,
                  id: 1,
                  product_id: 14,
                  suggestion_img: "./static/LRimg/productsAll/9.jpg",
                  suggestion_title: "紧致提升雕塑系列 ",
                  suggestion_mj: "5-1# 凝珠精华霜 ( 小雕塑霜 )",
                  suggestion_price: "￥738.00",
                  suggestion_specifications: "30ml"
                },
                {
                  series_id: 10,
                  id: 0,
                  product_id: 19,
                  suggestion_img: "./static/LRimg/productsAll/10.jpg",
                  suggestion_title: "隔离防护系列 ",
                  suggestion_mj: "6#隔离精华乳",
                  suggestion_price: "￥480.00",
                  suggestion_specifications: "50g"
                }
              ]
            }
          ]
        },
        //6#隔离精华乳
        {
          product_id: 19,
          product_img: "./static/LRimg/productsAll/10.jpg",
          product_title: "隔离防护系列 ",
          product_mj: "6# 隔离精华乳",
          product_price: "￥480.00",
          product_specifications: "50g",
          mj_school_poster: "./static/YTimg/videohead/6.jpg",
          mj_school_video: "http://video.anab.com.cn/12.mp4",
          pro_mj_detail: [
            {
              mj_school_head: "./static/YTimg/detailsV/6.jpg",
              product_mj: "6# 隔离精华乳",
              product_title: "隔离防护系列",
              pro_mj_Summary:
                "肌肤的防护衣，集隔离、保湿、防护三效合一的精华型隔离乳液。",
              product_price: "￥480.00",
              product_specifications: "50g",
              product_img: "./static/LRimg/productsAll/10.jpg",
              product_img2: "./static/LRimg/productsAll2/6.jpg",
              product_effect:
                "添加了天然的向日葵精华、菜籽精华与油脂吸附粉末，一款兼具美容效果的隔离防护产品。功效卓越，能保护肌肤，避免肌肤受到紫外线、环境辐射、汽车尾气与空气污染的伤害。油脂吸附粉末，防汗防水，能长时间保持肌肤清爽，作为妆前乳使用能够长效维持妆容细致，炎热季节使用也不会感到黏腻厚重。",
              product_explain:
                "保养工作后，化妆前使用，取一元硬币大小的量均匀涂抹于面部，轻轻拍打覆盖肌肤。",
              collocation_suggestion: [
                {
                  series_id: 3,
                  id: 0,
                  product_id: 2,
                  suggestion_img: "./static/LRimg/productsAll/1.jpg",
                  suggestion_title: "清洁系列 ",
                  suggestion_mj: "1# 柔和卸妆乳",
                  suggestion_price: "￥480.00",
                  suggestion_specifications: "150ml"
                },
                {
                  series_id: 4,
                  id: 3,
                  product_id: 5,
                  suggestion_img: "./static/LRimg/productsAll/3.jpg",
                  suggestion_title: "保湿滋养系列 ",
                  suggestion_mj: "4# 保湿整肤液",
                  suggestion_price: "￥530.00",
                  suggestion_specifications: "100ml"
                },
                {
                  series_id: 4,
                  id: 1,
                  product_id: 7,
                  suggestion_img: "./static/LRimg/productsAll/8.jpg",
                  suggestion_title: "保湿滋养系列 ",
                  suggestion_mj: "5# 活力保湿霜",
                  suggestion_price: "￥530.00",
                  suggestion_specifications: "50ml"
                }
              ]
            }
          ]
        }
      ]
    },

    {
      series_id: 2,
      series_name: "新品上市",
      isnull: "a",
      product_list: [
        //6#隔离精华乳
        {
          product_id: 19,
          product_img: "./static/LRimg/productsAll/10.jpg",
          product_title: "隔离防护系列 ",
          product_mj: "6# 隔离精华乳",
          product_price: "￥480.00",
          product_specifications: "50g",
          mj_school_poster: "./static/YTimg/videohead/6.jpg",
          mj_school_video: "http://video.anab.com.cn/12.mp4",
          pro_mj_detail: [
            {
              mj_school_head: "./static/YTimg/detailsV/6.jpg",
              product_mj: "6# 隔离精华乳",
              product_title: "隔离防护系列",
              pro_mj_Summary:
                "肌肤的防护衣，集隔离、保湿、防护三效合一的精华型隔离乳液。",
              product_price: "￥480.00",
              product_specifications: "50g",
              product_img: "./static/LRimg/productsAll/10.jpg",
              product_img2: "./static/LRimg/productsAll2/6.jpg",
              product_effect:
                "添加了天然的向日葵精华、菜籽精华与油脂吸附粉末，一款兼具美容效果的隔离防护产品。功效卓越，能保护肌肤，避免肌肤受到紫外线、环境辐射、汽车尾气与空气污染的伤害。油脂吸附粉末，防汗防水，能长时间保持肌肤清爽，作为妆前乳使用能够长效维持妆容细致，炎热季节使用也不会感到黏腻厚重。",
              product_explain:
                "保养工作后，化妆前使用，取一元硬币大小的量均匀涂抹于面部，轻轻拍打覆盖肌肤。",
              collocation_suggestion: [
                {
                  series_id: 3,
                  id: 0,
                  product_id: 2,
                  suggestion_img: "./static/LRimg/productsAll/1.jpg",
                  suggestion_title: "清洁系列 ",
                  suggestion_mj: "1# 柔和卸妆乳",
                  suggestion_price: "￥480.00",
                  suggestion_specifications: "150ml"
                },
                {
                  series_id: 4,
                  id: 3,
                  product_id: 5,
                  suggestion_img: "./static/LRimg/productsAll/3.jpg",
                  suggestion_title: "保湿滋养系列 ",
                  suggestion_mj: "4# 保湿整肤液",
                  suggestion_price: "￥530.00",
                  suggestion_specifications: "100ml"
                },
                {
                  series_id: 4,
                  id: 1,
                  product_id: 7,
                  suggestion_img: "./static/LRimg/productsAll/8.jpg",
                  suggestion_title: "保湿滋养系列 ",
                  suggestion_mj: "5# 活力保湿霜",
                  suggestion_price: "￥530.00",
                  suggestion_specifications: "50ml"
                }
              ]
            }
          ]
        }
      ]
    },

    {
      series_id: 3,
      series_name: "清洁系列",
      isnull: "a",
      product_list: [
        //1#柔和卸妆乳
        {
          product_id: 1,
          product_img: "./static/LRimg/productsAll/1.jpg",
          product_title: "清洁系列 ",
          product_mj: "1# 柔和卸妆乳",
          product_price: "￥480.00",
          product_specifications: "150ml",
          mj_school_poster: "./static/YTimg/videohead/1.jpg",
          mj_school_video: "http://video.anab.com.cn/2.mp4",
          pro_mj_detail: [
            {
              mj_school_head: "./static/YTimg/detailsV/1.jpg",
              product_mj: "1# 柔和卸妆乳",
              product_title: "清洁系列 ",
              pro_mj_Summary:
                "肌肤的吸尘器，可直接冲洗不需要乳化的清爽型卸妆凝乳。 ",
              product_price: "￥480.00",
              product_specifications: "150ml",
              product_img: "./static/LRimg/productsAll/1.jpg",
              product_img2: "./static/LRimg/productsAll2/anab1.jpg",
              product_effect:
                "非乳化型卸妆凝乳，丰富添加P.C.A植物精华, 卸妆同时为肌肤补充营养，保持肌肤滋润及通透洁净。",
              product_explain:
                "干手干脸均匀覆盖脸部，轻柔按摩30秒后，用温毛巾擦拭干净。",
              collocation_suggestion: [
                {
                  series_id: 3,
                  id: 2,
                  product_id: 2,
                  suggestion_img: "./static/LRimg/productsAll/11.jpg",
                  suggestion_title: "清洁系列 ",
                  suggestion_mj: "7# 水溶性凝胶",
                  suggestion_price: "￥480.00",
                  suggestion_specifications: "260g"
                },
                {
                  series_id: 4,
                  id: 3,
                  product_id: 3,
                  suggestion_img: "./static/LRimg/productsAll/3.jpg",
                  suggestion_title: "保湿滋养系列 ",
                  suggestion_mj: "4# 保湿整肤液",
                  suggestion_price: "￥530.00",
                  suggestion_specifications: "100ml"
                },
                {
                  series_id: 10,
                  id: 0,
                  product_id: 4,
                  suggestion_img: "./static/LRimg/productsAll/1.jpg",
                  suggestion_title: "隔离防护系列 ",
                  suggestion_mj: "6# 隔离精华乳",
                  suggestion_price: "￥480.00",
                  suggestion_specifications: "50g"
                },
                {
                  series_id: 7,
                  id: 2,
                  product_id: 15,
                  suggestion_img: "./static/LRimg/productsAll/12.jpg",
                  suggestion_title: "紧致提升雕塑系列 ",
                  suggestion_mj: "8-1# 凝时精华眼霜",
                  suggestion_price: "￥680.00",
                  suggestion_specifications: "15ml"
                }
              ]
            }
          ]
        },
        //2# 柔和洁面乳
        {
          product_id: 2,
          product_img: "./static/LRimg/productsAll/2.jpg",
          product_title: "清洁系列 ",
          product_mj: "2# 柔和洁面乳",
          product_price: "￥530.00",
          product_specifications: "150ml",
          mj_school_poster: "./static/YTimg/videohead/2.jpg",
          mj_school_video: "http://video.anab.com.cn/3.mp4",
          pro_mj_detail: [
            {
              mj_school_head: "./static/YTimg/detailsV/2.jpg",
              product_mj: "2# 柔和洁面乳",
              product_title: "清洁系列 ",
              pro_mj_Summary:
                "奶油般质地的浓密泡泡，洁面同时软化角质，肌肤清爽细致。 ",
              product_price: "￥530.00",
              product_specifications: "150ml",
              product_img: "./static/LRimg/productsAll/2.jpg",
              product_img2: "./static/LRimg/productsAll2/anab2.jpg",
              product_effect:
                "添加多种植物精华成分与P.C.A提取物，泡泡中含有去角质微粒，洁面同时软化角质，清洁毛孔中的油脂及污垢。洁面后肌肤细滑光洁。",
              product_explain: "推动奶泡，清洁面部。",
              collocation_suggestion: [
                {
                  series_id: 4,
                  id: 3,
                  product_id: 5,
                  suggestion_img: "./static/LRimg/productsAll/3.jpg",
                  suggestion_title: "保湿滋养系列 ",
                  suggestion_mj: "4# 保湿整肤液",
                  suggestion_price: "￥530.00",
                  suggestion_specifications: "100ml"
                },
                {
                  series_id: 10,
                  id: 0,
                  product_id: 19,
                  suggestion_img: "./static/LRimg/productsAll/10.jpg",
                  suggestion_title: "隔离防护系列 ",
                  suggestion_mj: "6# 隔离精华乳",
                  suggestion_price: "￥480.00",
                  suggestion_specifications: "50g"
                },
                {
                  series_id: 9,
                  id: 1,
                  product_id: 20,
                  suggestion_img: "./static/LRimg/productsAll/18.jpg",
                  suggestion_title: "光皙焕颜系列",
                  suggestion_mj: "C Powder 面膜粉",
                  suggestion_price: "￥622.00",
                  suggestion_specifications: "0.7g x 包"
                },
                {
                  series_id: 9,
                  id: 0,
                  product_id: 19,
                  suggestion_img: "./static/LRimg/productsAll/16.jpg",
                  suggestion_title: "光皙焕颜系列",
                  suggestion_mj: "EGF活肽粉",
                  suggestion_price: "￥380.00",
                  suggestion_specifications: "2对"
                }
              ]
            }
          ]
        },
        //7# 水溶性凝胶
        {
          product_id: 3,
          product_img: "./static/LRimg/productsAll/11.jpg",
          product_title: "清洁系列 ",
          product_mj: "7# 水溶性凝胶",
          product_price: "￥480.00",
          product_specifications: "260g",
          mj_school_poster: "./static/YTimg/videohead/7.jpg",
          mj_school_video: "http://video.anab.com.cn/13.mp4",
          pro_mj_detail: [
            {
              mj_school_head: "./static/YTimg/detailsV/7.jpg",
              product_mj: "7# 水溶性凝胶",
              product_title: "清洁系列 ",
              pro_mj_Summary: "一瓶为肌肤补充营养兼具清洁污垢的拍拍凝胶水面膜。",
              product_price: "￥480.00",
              product_specifications: "260g",
              product_img: "./static/LRimg/productsAll/11.jpg",
              product_img2: "./static/LRimg/productsAll2/7.jpg",
              product_effect:
                "富含神经酰胺、维他命成分，兼具提亮、保湿、清洁及为肌肤补充营养的功能。可做为保湿面膜与肌肤清洁使用。",
              product_explain:
                "干手干脸均匀覆盖面部，轻拍5分钟，停留10分钟后洗净",
              collocation_suggestion: [
                {
                  series_id: 3,
                  id: 0,
                  product_id: 2,
                  suggestion_img: "./static/LRimg/productsAll/1.jpg",
                  suggestion_title: "清洁系列 ",
                  suggestion_mj: "1# 柔和卸妆乳",
                  suggestion_price: "￥480.00",
                  suggestion_specifications: "150ml"
                },
                {
                  series_id: 5,
                  id: 0,
                  product_id: 9,
                  suggestion_img: "./static/LRimg/productsAll/3.jpg",
                  suggestion_title: "活颜精华系列",
                  suggestion_mj: "3# 纯净精华液",
                  suggestion_price: "￥998.00",
                  suggestion_specifications: "40ml"
                },
                {
                  series_id: 4,
                  id: 3,
                  product_id: 5,
                  suggestion_img: "./static/LRimg/productsAll/7.jpg",
                  suggestion_title: "保湿滋养系列 ",
                  suggestion_mj: "4# 保湿整肤液",
                  suggestion_price: "￥530.00",
                  suggestion_specifications: "100ml"
                },
                {
                  series_id: 10,
                  id: 0,
                  product_id: 19,
                  suggestion_img: "./static/LRimg/productsAll/10.jpg",
                  suggestion_title: "隔离防护系列 ",
                  suggestion_mj: "6# 隔离精华乳",
                  suggestion_price: "￥480.00",
                  suggestion_specifications: "50g"
                }
              ]
            }
          ]
        }
      ]
    },

    {
      series_id: 4,
      series_name: "保湿滋养系列",
      isnull: "a",
      product_list: [
        //保湿小分子水素喷雾
        {
          product_id: 4,
          product_img: "./static/LRimg/productsAll/14.jpg",
          product_title: "保湿滋养系列 ",
          product_mj: "保湿小分子水素喷雾",
          product_price: "￥597.00",
          product_specifications: "120ml",
          mj_school_poster: "./static/YTimg/videohead/21.jpg",
          mj_school_video: "http://video.anab.com.cn/17.mp4",
          pro_mj_detail: [
            {
              mj_school_head: "./static/YTimg/detailsV/21.jpg",
              product_mj: "保湿小分子水素喷雾",
              product_title: "保湿滋养系列 ",
              pro_mj_Summary:
                "丰富添加薰衣草花水，唤醒沉睡的肌肤。 ",
              product_price: "￥597.00",
              product_specifications: "120ml",
              product_img: "./static/LRimg/productsAll/14.jpg",
              product_img2: "./static/LRimg/productsAll2/anab21.jpg",
              product_effect:
                "水素水饱含植物成分，紧锁水分，有效平衡肌肤酸碱值。迅速为肌肤补水外同时兼具修护皮肤问题等功效，敏感肌肤适用。",
              product_explain:
                "半臂距离喷洒于肌肤上，轻拍至吸收最佳；化妆前，喷洒于肌肤上，在使用化妆品可使妆容持久靓丽。",
              collocation_suggestion: [
                {
                  series_id: 5,
                  id: 1,
                  product_id: 10,
                  suggestion_img: "./static/LRimg/productsAll/4.jpg",
                  suggestion_title: "活颜精华系列 ",
                  suggestion_mj: "3-1# 活颜精华露",
                  suggestion_price: "￥798.00",
                  suggestion_specifications: "40ml"
                },
                {
                  series_id: 5,
                  id: 0,
                  product_id: 9,
                  suggestion_img: "./static/LRimg/productsAll/3.jpg",
                  suggestion_title: "活颜精华系列 ",
                  suggestion_mj: "3# 纯净精华液",
                  suggestion_price: "￥998.00",
                  suggestion_specifications: "40ml"
                },
                {
                  series_id: 9,
                  id: 1,
                  product_id: 20,
                  suggestion_img: "./static/LRimg/productsAll/18.jpg",
                  suggestion_title: "光皙焕颜系列 ",
                  suggestion_mj: "C Powder 面膜粉",
                  suggestion_price: "￥622.00",
                  suggestion_specifications: "0.7g x 包"
                }
              ]
            }
          ]
        },
        //5#活力保湿霜
        {
          product_id: 7,
          product_img: "./static/LRimg/productsAll/8.jpg",
          product_title: "保湿滋养系列 ",
          product_mj: "5# 活力保湿霜",
          product_price: "￥530.00",
          product_specifications: "50ml",
          mj_school_poster: "./static/YTimg/videohead/5.jpg",
          mj_school_video: "http://video.anab.com.cn/9.mp4",
          pro_mj_detail: [
            {
              mj_school_head: "./static/YTimg/detailsV/5.jpg",
              product_mj: "5# 活力保湿霜",
              product_title: "保湿滋养系列 ",
              pro_mj_Summary:
                "如同保护膜一般，能够在肌肤表层起到长时间锁水滋润效果。 ",
              product_price: "￥530.00 ",
              product_specifications: "50ml",
              product_img: "./static/LRimg/productsAll/8.jpg",
              product_img2: "./static/LRimg/productsAll2/anab5.jpg",
              product_effect:
                "添加保湿效果的角鲨烷、维生素E及植物提取精华，完整提供肌肤内层所需要的营养，同时在肌肤外层形成滋润的保护膜，长时间保持肌肤的状态。",
              product_explain: "按压1～2泵均匀涂抹于面部，兼具日晚霜功效。",
              collocation_suggestion: [
                {
                  series_id: 4,
                  id: 3,
                  product_id: 5,
                  suggestion_img: "./static/LRimg/productsAll/7.jpg",
                  suggestion_title: "保湿滋养系列 ",
                  suggestion_mj: "4# 保湿整肤液",
                  suggestion_price: "￥530.00",
                  suggestion_specifications: "100ml"
                },
                {
                  series_id: 7,
                  id: 1,
                  product_id: 14,
                  suggestion_img: "./static/LRimg/productsAll/9.jpg",
                  suggestion_title: "紧致提升雕塑系列 ",
                  suggestion_mj: "5-1# 凝珠精华霜 ( 小雕塑霜 )",
                  suggestion_price: "￥738.00",
                  suggestion_specifications: "30ml"
                },
                {
                  series_id: 10,
                  id: 0,
                  product_id: 19,
                  suggestion_img: "./static/LRimg/productsAll/10.jpg",
                  suggestion_title: "隔离防护系列 ",
                  suggestion_mj: "6#隔离精华乳",
                  suggestion_price: "￥480.00",
                  suggestion_specifications: "50g"
                }
              ]
            }
          ]
        },
        //10#睡眠面膜
        {
          product_id: 6,
          product_img: "./static/LRimg/productsAll/13.jpg",
          product_title: "保湿滋养系列 ",
          product_mj: "10# 睡眠面膜",
          product_price: "￥398.00",
          product_specifications: "40ml",
          mj_school_poster: "./static/YTimg/videohead/10.jpg",
          mj_school_video: "http://video.anab.com.cn/14.mp4",
          pro_mj_detail: [
            {
              mj_school_head: "./static/YTimg/detailsV/10.jpg",
              product_mj: "10# 睡眠面膜",
              product_title: "保湿滋养系列 ",
              pro_mj_Summary:
                "能让肌肤深度睡眠的夜间保鲜膜，深度保湿，整夜呵护，无需冲洗，令肌肤重现饱满盈润。 ",
              product_price: "￥398.00",
              product_specifications: "40ml",
              product_img: "./static/LRimg/productsAll/13.jpg",
              product_img2: "./static/LRimg/productsAll2/anab10.jpg",
              product_effect:
                "金黄色的凝胶状面膜，含丰富的水解蛋白与营养成分，具有修护、保湿等功效，在夜间充分润养肌肤，帮助肌肤进入深度睡眠，改善因夜间空调所造成的水分流失等肌肤问题，一觉醒来感受到肌肤的饱满光泽。",
              product_explain:
                "睡眠面膜：睡前薄薄一层均匀涂敷于肌肤；急救面膜：清洁后厚敷肌肤上约5至10分钟后，清水洗净。",
              collocation_suggestion: [
                {
                  series_id: 4,
                  id: 3,
                  product_id: 5,
                  suggestion_img: "./static/LRimg/productsAll/7.jpg",
                  suggestion_title: "保湿滋养系列 ",
                  suggestion_mj: "4# 保湿整肤液",
                  suggestion_price: "￥530.00",
                  suggestion_specifications: "100ml"
                },
                {
                  series_id: 9,
                  id: 1,
                  product_id: 20,
                  suggestion_img: "./static/LRimg/productsAll/18.jpg",
                  suggestion_title: "光皙焕颜系列 ",
                  suggestion_mj: "C Powder 面膜粉",
                  suggestion_price: "￥622.00",
                  suggestion_specifications: "0.7g x 10包"
                }
              ]
            }
          ]
        },
        //4#保湿整肤液
        {
          product_id: 5,
          product_img: "./static/LRimg/productsAll/7.jpg",
          product_title: "保湿滋养系列 ",
          product_mj: "4# 保湿整肤液",
          product_price: "￥530.00",
          product_specifications: "100ml",
          mj_school_poster: "./static/YTimg/videohead/4.jpg",
          mj_school_video: "http://video.anab.com.cn/8.mp4",
          pro_mj_detail: [
            {
              mj_school_head: "./static/YTimg/detailsV/4.jpg",
              product_mj: "4# 保湿整肤液",
              product_title: "保湿滋养系列 ",
              pro_mj_Summary:
                "浓密型态的保湿美容整肤液，充分浸润肌肤，使肌肤像喝饱了水一般的呈现饱满光泽。 ",
              product_price: "￥530.00",
              product_specifications: "100ml",
              product_img: "./static/LRimg/productsAll/7.jpg",
              product_img2: "./static/LRimg/productsAll2/anab4.jpg",
              product_effect:
                "质地盈润，分层保湿，富含P.C.A植物提取精华，有效平衡肌肤状态，改善肌肤干荒暗哑，深度保湿。",
              product_explain:
                "按压2～3泵，轻拍至肌肤吸收；化妆棉浸透后湿敷密集补水；与纯净水调稀后可做化妆水使用。",
              collocation_suggestion: [
                {
                  series_id: 4,
                  id: 1,
                  product_id: 7,
                  suggestion_img: "./static/LRimg/productsAll/8.jpg",
                  suggestion_title: "保湿滋养系列 ",
                  suggestion_mj: "5# 活力保湿霜",
                  suggestion_price: "￥530.00",
                  suggestion_specifications: "50ml"
                },
                {
                  series_id: 7,
                  id: 1,
                  product_id: 14,
                  suggestion_img: "./static/LRimg/productsAll/9.jpg",
                  suggestion_title: "紧致提升雕塑系列 ",
                  suggestion_mj: "5-1# 凝珠精华霜 ( 小雕塑霜 )",
                  suggestion_price: "￥738.00",
                  suggestion_specifications: "30ml"
                },
                {
                  series_id: 8,
                  id: 0,
                  product_id: 17,
                  suggestion_img: "./static/LRimg/productsAll/17.jpg",
                  suggestion_title: "铂金酵素系列 ",
                  suggestion_mj: "美肌精",
                  suggestion_price: "￥2180.00",
                  suggestion_specifications: "120ml"
                },
                {
                  series_id: 10,
                  id: 0,
                  product_id: 19,
                  suggestion_img: "./static/LRimg/productsAll/10.jpg",
                  suggestion_title: "隔离防护系列 ",
                  suggestion_mj: "6# 隔离精华乳",
                  suggestion_price: "￥480.00",
                  suggestion_specifications: "50g"
                }
              ]
            }
          ]
        },

        //水源盈润美肤霜
        // 没有
        {
          product_id: 8,
          product_img: "./static/LRimg/productsAll/19.jpg",
          product_title: "保湿滋养系列 ",
          product_mj: "水源盈润美肤霜",
          product_price: "￥699.00",
          product_specifications: "50g",
          mj_school_poster: "./static/YTimg/videohead/20.jpg",
          mj_school_video: "http://video.anab.com.cn/20.mp4",
          pro_mj_detail: [
            {
              mj_school_head: "./static/YTimg/detailsV/20.jpg",
              product_mj: "水源盈润美肤霜",
              product_title: "保湿滋养系列 ",
              pro_mj_Summary:
                "布丁状QQ的凝霜质地，抹开即化为露水状态的保湿水面霜。 ",
              product_price: "￥699.00",
              product_specifications: "50g",
              product_img: "./static/LRimg/productsAll/19.jpg",
              product_img2: "./static/LRimg/productsAll2/anab20.jpg",
              product_effect:
                "清爽的保湿水面霜，独特布丁QQ状凝霜质地，遇肤温抹开后即化为露水状态，添加3种神经酰胺与植物提取精华，为肌肤源源不断输送养分与水分。",
              product_explain: "•取适量均匀涂抹于面部，兼具日晚霜功效",
              collocation_suggestion: [
                {
                  series_id: 3,
                  id: 2,
                  product_id: 3,
                  suggestion_img: "./static/LRimg/productsAll/11.jpg",
                  suggestion_title: "清洁系列",
                  suggestion_mj: "7# 水溶性凝胶",
                  suggestion_price: "￥480.00",
                  suggestion_specifications: "260g"
                },
                {
                  series_id: 4,
                  id: 3,
                  product_id: 5,
                  suggestion_img: "./static/LRimg/productsAll/7.jpg",
                  suggestion_title: "保湿滋养系列 ",
                  suggestion_mj: "4# 保湿整肤液",
                  suggestion_price: "￥530.00",
                  suggestion_specifications: "100ml"
                },
                {
                  series_id: 10,
                  id: 0,
                  product_id: 4,
                  suggestion_img: "./static/LRimg/productsAll/1.jpg",
                  suggestion_title: "隔离防护系列 ",
                  suggestion_mj: "6# 隔离精华乳",
                  suggestion_price: "￥480.00",
                  suggestion_specifications: "50g"
                }
              ]
            }
          ]
        }
      ]
    },
    {
      series_id: 5,
      series_name: "活颜精华系列",
      isnull: "a",
      product_list: [
        //3#纯净精华液
        {
          product_id: 9,
          product_img: "./static/LRimg/productsAll/3.jpg",
          product_title: "活颜精华系列",
          product_mj: "3# 纯净精华液",
          product_price: "￥998.00",
          product_specifications: "40ml",
          mj_school_poster: "./static/YTimg/videohead/3.jpg",
          mj_school_video: "http://video.anab.com.cn/4.mp4",
          pro_mj_detail: [
            {
              mj_school_head: "./static/YTimg/detailsV/3.jpg",
              product_mj: "3# 纯净精华液",
              product_title: "活颜精华系列 ",
              pro_mj_Summary:
                "为肌底倾注活力，改善肌肤机能，提升后续保养品的功效。 ",
              product_price: "￥998.00",
              product_specifications: "40ml",
              product_img: "./static/LRimg/productsAll/3.jpg",
              product_img2: "./static/LRimg/productsAll2/anab3.jpg",
              product_effect:
                "富含P.C.A植物提取精华，集中养护肌肤、补充营养、润泽肌底，调整并稳定肌肤状态，辅助并提高后续保养效果。",
              product_explain: "清洁后，按压2泵，均匀涂抹于面部，轻拍至吸收。",
              collocation_suggestion: [
                {
                  series_id: 4,
                  id: 0,
                  product_id: 4,
                  suggestion_img: "./static/LRimg/productsAll/14.jpg",
                  suggestion_title: "保湿滋养系列 ",
                  suggestion_mj: "保湿小分子水素喷雾",
                  suggestion_price: "￥597.00",
                  suggestion_specifications: "120ml"
                },
                {
                  series_id: 5,
                  id: 1,
                  product_id: 10,
                  suggestion_img: "./static/LRimg/productsAll/4.jpg",
                  suggestion_title: "活颜精华系列 ",
                  suggestion_mj: "3-1# 活颜精华露",
                  suggestion_price: "￥798.00",
                  suggestion_specifications: "40ml"
                },
                {
                  series_id: 7,
                  id: 0,
                  product_id: 13,
                  suggestion_img: "./static/LRimg/productsAll/5.jpg",
                  suggestion_title: "紧致提升雕塑系列 ",
                  suggestion_mj: "3-2# 提升紧致精华啫喱",
                  suggestion_price: "￥1290.00",
                  suggestion_specifications: "40ml"
                },
                {
                  series_id: 8,
                  id: 1,
                  product_id: 18,
                  suggestion_img: "./static/LRimg/productsAll/15.jpg",
                  suggestion_title: "铂金酵素系列 ",
                  suggestion_mj: "光肌精",
                  suggestion_price: "￥2180.00",
                  suggestion_specifications: "80g"
                }
              ]
            }
          ]
        },
        //3-1#活颜精华露
        {
          product_id: 10,
          product_img: "./static/LRimg/productsAll/4.jpg",
          product_title: "活颜精华系列 ",
          product_mj: "3-1# 活颜精华露",
          product_price: "￥798.00",
          product_specifications: "40ml",
          mj_school_poster: "./static/YTimg/videohead/3-1.jpg",
          mj_school_video: "http://video.anab.com.cn/5.mp4",
          pro_mj_detail: [
            {
              mj_school_head: "./static/YTimg/detailsV/3-1.jpg",
              product_mj: "3-1# 活颜精华露",
              product_title: "活颜精华系列 ",
              pro_mj_Summary:
                "法国勃艮地葡萄精华发酵萃取，焕活肌肤，匀亮肤色，更显无暇光彩。 ",
              product_price: "￥798.00",
              product_specifications: "40ml",
              product_img: "./static/LRimg/productsAll/4.jpg",
              product_img2: "./static/LRimg/productsAll2/anab3-1.jpg",
              product_effect:
                "使用法国勃艮地葡萄精华发酵萃取，有效滋养，令肌肤更加纯净细腻，对于肌肤因加龄或外界有害物质引起的暗淡、痘印等问题，具有良好的提亮肤色功效。",
              product_explain: "按压2泵均匀涂抹于面部，轻拍至吸收",
              collocation_suggestion: [
                {
                  series_id: 4,
                  id: 0,
                  product_id: 4,
                  suggestion_img: "./static/LRimg/productsAll/14.jpg",
                  suggestion_title: "保湿滋养系列 ",
                  suggestion_mj: "保湿小分子水素喷雾",
                  suggestion_price: "￥597.00",
                  suggestion_specifications: "120ml"
                },
                {
                  series_id: 5,
                  id: 0,
                  product_id: 9,
                  suggestion_img: "./static/LRimg/productsAll/3.jpg",
                  suggestion_title: "活颜精华系列 ",
                  suggestion_mj: "3# 纯净精华液",
                  suggestion_price: "￥998.00",
                  suggestion_specifications: "40ml"
                },
                {
                  series_id: 7,
                  id: 0,
                  product_id: 13,
                  suggestion_img: "./static/LRimg/productsAll/5.jpg",
                  suggestion_title: "紧致提升雕塑系列 ",
                  suggestion_mj: "3-2# 提升紧致精华啫喱",
                  suggestion_price: "￥1290.00",
                  suggestion_specifications: "40ml"
                },
                {
                  series_id: 8,
                  id: 1,
                  product_id: 18,
                  suggestion_img: "./static/LRimg/productsAll/15.jpg",
                  suggestion_title: "铂金酵素系列 ",
                  suggestion_mj: "光肌精",
                  suggestion_price: "￥2180.00",
                  suggestion_specifications: "80g"
                }
              ]
            }
          ]
        },
        {
          product_id: 11,
          product_img: "./static/LRimg/productsAll/6.jpg",
          product_title: "活颜精华系列 ",
          product_mj: "3-3# 肌肤精华乳",
          product_price: "￥998.00",
          product_specifications: "40ml",
          mj_school_poster: "./static/YTimg/videohead/3-3.jpg",
          mj_school_video: "http://video.anab.com.cn/7.mp4",
          pro_mj_detail: [
            {
              mj_school_head: "./static/YTimg/detailsV/3-3.jpg",
              product_mj: "3-3# 肌肤精华乳",
              product_title: "活颜精华系列",
              pro_mj_Summary: "针对修护敏感脆弱肌肤而诞生的修护型精华乳。",
              product_price: "￥998.00",
              product_specifications: "40ml",
              product_img: "./static/LRimg/productsAll/6.jpg",
              product_img2: "./static/LRimg/productsAll2/anab3-3.jpg",
              product_effect:
                "肌肤精华乳特别添加了3种不同分子结构的神经酰胺，深度保湿，强健肌肤屏障与其保护功能。珍贵的黄金蜂胶蛋白具有良好的修护效果，协同多种神奇的植物草本提取物，为肌肤补充营养，稳定肌肤自身机能。",
              product_explain: "清洁后，按压2～3泵，均匀涂抹于面部，轻拍至吸收。",
              collocation_suggestion: [
                {
                  series_id: 6,
                  id: 1,
                  product_id: 12,
                  suggestion_img: "./static/LRimg/productsAll/8.jpg",
                  suggestion_title: "舒敏修护系列 ",
                  suggestion_mj: "5-2# 滋润修护霜",
                  suggestion_price: "￥560.00",
                  suggestion_specifications: "50g"
                },
                {
                  series_id: 4,
                  id: 3,
                  product_id: 5,
                  suggestion_img: "./static/LRimg/productsAll/7.jpg",
                  suggestion_title: "保湿滋养系列",
                  suggestion_mj: "4# 保湿整肤液",
                  suggestion_price: "￥530.00",
                  suggestion_specifications: "100ml"
                },
                {
                  series_id: 10,
                  id: 0,
                  product_id: 4,
                  suggestion_img: "./static/LRimg/productsAll/1.jpg",
                  suggestion_title: "隔离防护系列 ",
                  suggestion_mj: "6# 隔离精华乳",
                  suggestion_price: "￥480.00",
                  suggestion_specifications: "50g"
                }
              ]
            }
          ]
        },
      ]
    },
    {
      series_id: 6,
      series_name: "舒敏修护系列",
      isnull: "a",
      product_list: [
        //3-3#肌肤精华乳
        //5-2#滋润修护霜
        {
          product_id: 12,
          product_img: "./static/LRimg/productsAll/8.jpg",
          product_title: "舒敏修护系列",
          product_mj: "5-2# 滋润修护霜",
          product_price: "￥560.00",
          product_specifications: "50g",
          mj_school_poster: "./static/YTimg/videohead/5-2.jpg",
          mj_school_video: "http://video.anab.com.cn/11.mp4",
          pro_mj_detail: [
            {
              mj_school_head: "./static/YTimg/detailsV/5-2.jpg",
              product_mj: "5-2# 滋润修护霜",
              product_title: "舒敏修护系列 ",
              pro_mj_Summary:
                "添加5种具有舒敏修护功效的神奇植物萃取，修护受损肌肤，浓郁滋润敏弱肌肤的修护型面霜。 ",
              product_price: "￥560.00",
              product_specifications: "50g",
              product_img: "./static/LRimg/productsAll/8.jpg",
              product_img2: "./static/LRimg/productsAll2/5-2.jpg",
              product_effect:
                "质地馥郁浓密的滋养修护型面霜。除添加保湿成分角鲨烷与小分子水解蛋白外，含有5种珍贵的植物提取物*，有效修护受损的肌肤、帮助强健肌肤的防护功能，呵护敏感脆弱肌",
              product_explain:
                "按压1～2泵均匀涂抹于面部。",
              collocation_suggestion: [
                {
                  series_id: 4,
                  id: 0,
                  product_id: 4,
                  suggestion_img: "./static/LRimg/productsAll/14.jpg",
                  suggestion_title: "保湿滋养系列",
                  suggestion_mj: "保湿小分子水素喷雾",
                  suggestion_price: "￥597.00",
                  suggestion_specifications: "120ml"
                },
                {
                  series_id: 3,
                  id: 2,
                  product_id: 3,
                  suggestion_img: "./static/LRimg/productsAll/11.jpg",
                  suggestion_title: "清洁系列",
                  suggestion_mj: "7# 水溶性凝胶",
                  suggestion_price: "￥480.00",
                  suggestion_specifications: "260g"
                }
              ]
            }
          ]
        }
      ]
    },
    {
      series_id: 7,
      series_name: "紧致提升雕塑系列",
      isnull: "a",
      product_list: [
        //3-2#提升紧致精华啫哩
        {
          product_id: 13,
          product_img: "./static/LRimg/productsAll/5.jpg",
          product_title: "紧致提升雕塑系列 ",
          product_mj: "3-2# 提升紧致精华啫喱",
          product_price: "￥1290.00",
          product_specifications: "40ml",
          mj_school_poster: "./static/YTimg/videohead/3-2.jpg",
          mj_school_video: "http://video.anab.com.cn/6.mp4",
          pro_mj_detail: [
            {
              mj_school_head: "./static/YTimg/detailsV/3-2.jpg",
              product_mj: "3-2# 提升紧致精华啫喱",
              product_title: "紧致提升雕塑系列",
              pro_mj_Summary:
                "弹力拉丝提拉雕塑精华，一款结合收紧提拉与紧致塑颜的面部雕塑产品。",
              product_price: "￥1290.00",
              product_specifications: "40ml",
              product_img: "./static/LRimg/productsAll/5.jpg",
              product_img2: "./static/LRimg/productsAll2/anab3-2.jpg",
              product_effect:
                "内含新型态双胶原与水解蛋白，利用科技性的技术，使啫喱质地将在轻轻拍打后产生弹力丝，涂抹后30秒即可吸收，并在肌肤表面形成隐形的弹力网，多方位雕塑立体轮廓。",
              product_explain:
                "按压2泵于掌心，双手轻拍产生弹力丝，由下往上涂抹提拉肌肤至吸收。",
              collocation_suggestion: [
                {
                  series_id: 5,
                  id: 0,
                  product_id: 9,
                  suggestion_img: "./static/LRimg/productsAll/3.jpg",
                  suggestion_title: "活颜精华系列 ",
                  suggestion_mj: "3# 纯净精华液",
                  suggestion_price: "￥998.00",
                  suggestion_specifications: "40ml"
                },
                {
                  series_id: 8,
                  id: 1,
                  product_id: 18,
                  suggestion_img: "./static/LRimg/productsAll/15.jpg",
                  suggestion_title: "铂金酵素系列 ",
                  suggestion_mj: "光肌精",
                  suggestion_price: "￥2180.00",
                  suggestion_specifications: "80g"
                },
                {
                  series_id: 8,
                  id: 0,
                  product_id: 17,
                  suggestion_img: "./static/LRimg/productsAll/17.jpg",
                  suggestion_title: "铂金酵素系列 ",
                  suggestion_mj: "美肌精",
                  suggestion_price: "￥2180.00",
                  suggestion_specifications: "120ml"
                }
              ]
            }
          ]
        },
        //5-1#鱼子精华霜
        {
          product_id: 14,
          product_img: "./static/LRimg/productsAll/9.jpg",
          product_title: "紧致提升雕塑系列",
          product_mj: "5-1# 凝珠精华霜 ( 小雕塑霜 )",
          product_price: "￥738.00",
          product_specifications: "30ml",
          mj_school_poster: "./static/YTimg/videohead/5-1.jpg",
          mj_school_video: "http://video.anab.com.cn/10.mp4",
          pro_mj_detail: [
            {
              mj_school_head: "./static/YTimg/detailsV/5-1.jpg",
              product_mj: "5-1# 凝珠精华霜 ( 小雕塑霜 )",
              product_title: "紧致提升雕塑系列 ",
              pro_mj_Summary:
                "使用日本专利新型态包膜载体技术，粒粒白色小圆珠为肌肤输送新鲜有效的修护成分 , 愉悦享受肌肤飨宴。",
              product_price: "￥738.00",
              product_specifications: "30ml",
              product_img: "./static/LRimg/productsAll/9.jpg",
              product_img2: "./static/LRimg/productsAll2/5-1anab.jpg",
              product_effect:
                "源自日本专利包膜载体技术，将植物提取物与营养成分粒粒精鲜包覆。一粒粒如鱼子般的白色小圆珠，有效地保护着珍贵新鲜的成分，使用时小圆珠将透过压嘴破裂流出，释放精华成分并输送给肌肤。兼具保湿、紧致与提拉雕塑的效果。",
              product_explain:
                "按压2泵，均匀涂抹于面部，由下往上涂抹提拉肌肤至吸收。",
              collocation_suggestion: [
                {
                  series_id: 4,
                  id: 3,
                  product_id: 5,
                  suggestion_img: "./static/LRimg/productsAll/7.jpg",
                  suggestion_title: "保湿滋养系列",
                  suggestion_mj: "4# 保湿整肤液",
                  suggestion_price: "￥530.00",
                  suggestion_specifications: "100ml"
                },
                {
                  series_id: 4,
                  id: 1,
                  product_id: 7,
                  suggestion_img: "./static/LRimg/productsAll/8.jpg",
                  suggestion_title: "保湿滋养系列 ",
                  suggestion_mj: "5# 活力保湿霜",
                  suggestion_price: "￥530.00",
                  suggestion_specifications: "50ml"
                }
              ]
            }
          ]
        },
        //8#胶原眼胶
        {
          product_id: 15,
          product_img: "./static/LRimg/productsAll/12.jpg",
          product_title: "紧致提升雕塑系列",
          product_mj: "8-1# 凝时精华眼霜",
          product_price: "￥680.00",
          product_specifications: "15ml",
          mj_school_poster: "./static/YTimg/videohead/8-1.jpg",
          mj_school_video: " ",
          pro_mj_detail: [
            {
             mj_school_head: "./static/YTimg/detailsV/8-1.jpg",
              product_mj: "8-1# 凝时精华眼霜",
              product_title: "紧致提升雕塑系列 ",
              pro_mj_Summary:
                "P.C.A植物提取精华深度滋养，密集修护眼周问题。。 ",
              product_price: "￥680.00",
              product_specifications: "15ml",
              product_img: "./static/LRimg/productsAll/12.jpg",
              product_img2: './static/LRimg/productsAll2/anab1.jpg',
              product_effect:
                "添加P.C.A植物精华提取物等多种营养成分，警钟针对眼部肌肤修护，紧致提亮眼周肌肤、淡褪微小细纹，增加眼部肌肤弹性，有效改善眼部肌肤问题，焕发眼部肌肤活力。",
              product_explain:
                "取适量眼霜敷于眼周肌肤，用指腹或按摩棒打圈按摩眼周，并向太阳穴提拉直至吸收。",
              collocation_suggestion: [
                {
                  series_id: 5,
                  id: 0,
                  product_id: 2,
                  suggestion_img: "./static/LRimg/productsAll/3.jpg",
                  suggestion_title: "活颜精华系列",
                  suggestion_mj: "3# 纯净精华液",
                  suggestion_price: "￥998.00",
                  suggestion_specifications: "40ml"
                },
                {
                  series_id: 7,
                  id: 0,
                  product_id: 13,
                  suggestion_img: "./static/LRimg/productsAll/5.jpg",
                  suggestion_title: "紧致提升雕塑系列 ",
                  suggestion_mj: "3-2# 提升紧致精华啫喱",
                  suggestion_price: "￥1290.00",
                  suggestion_specifications: "40ml"
                },
                {
                  series_id: 8,
                  id: 1,
                  product_id: 18,
                  suggestion_img: "./static/LRimg/productsAll/15.jpg",
                  suggestion_title: "铂金酵素系列 ",
                  suggestion_mj: "光肌精",
                  suggestion_price: "￥2180.00",
                  suggestion_specifications: "80g"
                }
              ]
            }
          ]
        }
      ]
    },
    {
      series_id: 8,
      series_name: "铂金酵素系列",
      isnull: "a",
      product_list: [
        //美肌精
        // 没有
        {
          product_id: 17,
          product_img: "./static/LRimg/productsAll/17.jpg",
          product_title: "铂金酵素系列 ",
          product_mj: "美肌精",
          product_price: "￥2180.00",
          product_specifications: "120ml",
          mj_school_poster: "./static/YTimg/videohead/19.jpg",
          mj_school_video: "http://video.anab.com.cn/19.mp4",
          pro_mj_detail: [
            {
              mj_school_head: "./static/YTimg/detailsV/19.jpg",
              product_mj: "美肌精",
              product_title: "铂金酵素系列",
              pro_mj_Summary:
                "日本专利植物酵素精华成分添加，快速渗透肌肤表层，润养肌肤，使肌肤由内至外焕发无暇光彩。",
              product_price: "￥2180.00",
              product_specifications: "120ml",
              product_img: "./static/LRimg/productsAll/17.jpg",
              product_img2: "./static/LRimg/productsAll2/anab19.jpg",
              product_effect:
                "浓密精华质地，建议搭配同系列光肌精同时使用，连续使用可令肌肤持久保湿，明亮光泽。 ",
              product_explain: "按压适量，均匀涂抹于面部，轻拍至吸收。",
              collocation_suggestion: [
                {
                  series_id: 8,
                  id: 1,
                  product_id: 18,
                  suggestion_img: "./static/LRimg/productsAll/15.jpg",
                  suggestion_title: "铂金酵素系列 ",
                  suggestion_mj: "光肌精",
                  suggestion_price: "￥2180.00",
                  suggestion_specifications: "80g"
                },
                {
                  series_id: 5,
                  id: 0,
                  product_id: 9,
                  suggestion_img: "./static/LRimg/productsAll/3.jpg",
                  suggestion_title: "活颜精华系列",
                  suggestion_mj: "3# 纯净精华液",
                  suggestion_price: "￥998.00",
                  suggestion_specifications: "40ml"
                },
                {
                  series_id: 7,
                  id: 0,
                  product_id: 13,
                  suggestion_img: "./static/LRimg/productsAll/5.jpg",
                  suggestion_title: "紧致提升雕塑系列 ",
                  suggestion_mj: "3-2# 提升紧致精华啫喱",
                  suggestion_price: "￥1290.00",
                  suggestion_specifications: "40ml"
                }
              ]
            }
          ]
        },
        //光肌精
        // 没有
        {
          product_id: 18,
          product_img: "./static/LRimg/productsAll/15.jpg",
          product_title: "铂金酵素系列",
          product_mj: "光肌精",
          product_price: "￥2180.00",
          product_specifications: "80g",
          mj_school_poster: "./static/YTimg/videohead/18.jpg",
          mj_school_video: "http://video.anab.com.cn/18.mp4",
          pro_mj_detail: [
            {
              mj_school_head: "./static/YTimg/detailsV/18.jpg",
              product_mj: "光肌精",
              product_title: "铂金酵素系列",
              pro_mj_Summary:
                "采用日本传统发酵技术并且结合科技萃取成分，酵素成分与铂金的融合，为肌肤倾注活力能量。",
              product_price: "￥2180.00",
              product_specifications: "80g",
              product_img: "./static/LRimg/productsAll/15.jpg",
              product_img2: "./static/LRimg/productsAll2/anab18.jpg",
              product_effect:
                "绵密霜状质地，建议搭配同系列美肌精同时使用，连续使用可令肌肤持久保湿，明亮光泽。",
              product_explain: "美肌精使用后，挖取适量，涂抹于面部，轻拍至吸收。",
              collocation_suggestion: [
                {
                  series_id: 8,
                  id: 0,
                  product_id: 18,
                  suggestion_img: "./static/LRimg/productsAll/17.jpg",
                  suggestion_title: "铂金酵素系列 ",
                  suggestion_mj: "美肌精",
                  suggestion_price: "￥2180.00",
                  suggestion_specifications: "120ml"
                },
                {
                  series_id: 5,
                  id: 0,
                  product_id: 9,
                  suggestion_img: "./static/LRimg/productsAll/3.jpg",
                  suggestion_title: "活颜精华系列",
                  suggestion_mj: "3# 纯净精华液",
                  suggestion_price: "￥998.00",
                  suggestion_specifications: "40ml"
                },
                {
                  series_id: 7,
                  id: 0,
                  product_id: 13,
                  suggestion_img: "./static/LRimg/productsAll/5.jpg",
                  suggestion_title: "紧致提升雕塑系列 ",
                  suggestion_mj: "3-2# 提升紧致精华啫喱",
                  suggestion_price: "￥1290.00",
                  suggestion_specifications: "40ml"
                }
              ]
            }
          ]
        }
      ]
    },
    {
      series_id: 9,
      series_name: "光皙焕颜系列",
      isnull: "a",
      product_list: [
        //EGF活肽粉
        {
          product_id: 19,
          product_img: "./static/LRimg/productsAll/16.jpg",
          product_title: "光皙焕颜系列 ",
          product_mj: "活肤修护保湿精华露",
          product_price: "￥380.00",
          product_specifications: "2对",
          mj_school_poster: "./static/YTimg/videohead/17.jpg",
          mj_school_video: "http://video.anab.com.cn/15.mp4",
          pro_mj_detail: [
            {
              mj_school_head: "./static/YTimg/detailsV/17.jpg",
              product_mj: "活肤修护保湿精华露",
              product_title: "光皙焕颜系列",
              pro_mj_Summary:
                "肌底修护精华组合，有效舒缓修护肌肤问题，强健肌肤屏障。",
              product_price: "￥480.00",
              product_specifications: "2对",
              product_img: "./static/LRimg/productsAll/16.jpg",
              product_img2: "./static/LRimg/productsAll2/anab17.jpg",
              product_effect:
                "使用了科技性配方，能够促进肌肤修护，针对痘痘、痘印、晒后损伤等肌肤问题进行修护，呵护肌肤健康。",
              product_explain:
                "精华粉与精华露1:1调制后，盖上内附喷头，洁面后直接喷洒于肌肤上，轻拍至吸收。",
              collocation_suggestion: [
                {
                  series_id: 4,
                  id: 3,
                  product_id: 5,
                  suggestion_img: "./static/LRimg/productsAll/7.jpg",
                  suggestion_title: "保湿滋养系列 ",
                  suggestion_mj: "4# 保湿整肤液",
                  suggestion_price: "￥530.00",
                  suggestion_specifications: "100ml"
                },
                {
                  series_id: 9,
                  id: 1,
                  product_id: 20,
                  suggestion_img: "./static/LRimg/productsAll/18.jpg",
                  suggestion_title: "光皙焕颜系列 ",
                  suggestion_mj: "C Powder 面膜粉",
                  suggestion_price: "￥622.00",
                  suggestion_specifications: "0.7g x 10包"
                }
              ]
            }
          ]
        },
        //C Powder 面膜粉
        {
          product_id: 20,
          product_img: "./static/LRimg/productsAll/18.jpg",
          product_title: "光皙焕颜系列",
          product_mj: "C Powder 面膜粉",
          product_price: "￥622.00",
          product_specifications: "0.7g x 10包",
          mj_school_poster: "./static/YTimg/videohead/16.jpg",
          mj_school_video: "http://video.anab.com.cn/16.mp4",
          pro_mj_detail: [
            {
              mj_school_head: "./static/YTimg/detailsV/mmf.jpg",
              product_mj: "C Powder 面膜粉",
              product_title: "光皙焕颜系列",
              pro_mj_Summary:
                "精纯的水溶性维生素C精华粉，一款稀释或直接使用的皮肤护理产品。",
              product_price: "￥622.00",
              product_specifications: "0.7g x 10包",
              product_img: "./static/LRimg/productsAll/18.jpg",
              product_img2: "./static/LRimg/productsAll2/anab16.jpg",
              product_effect:
                "针对痘痘痘印肌肤暗淡问题有提亮功效。维C能促进胶原蛋白合成帮助提升肌肤的弹性，有效紧致肌肤。油性痘痘肌肤使用能抑制油脂分泌、细致毛孔，增强肌肤屏障。",
              product_explain:
                "化妆水：纯净水30ml：1包比例调和后，用化妆棉沾取擦拭全脸后轻拍至吸收；亮肤面膜：纯净水30ml：1包比例调和后，用压缩面膜浸透后敷于面部，10～15分钟后取下并清洗面部；痘痘护理：取适量维C粉直接敷于痘痘或痘印上。",
              collocation_suggestion: [
                {
                  series_id: 4,
                  id: 3,
                  product_id: 5,
                  suggestion_img: "./static/LRimg/productsAll/7.jpg",
                  suggestion_title: "保湿滋养系列 ",
                  suggestion_mj: "4# 保湿整肤液",
                  suggestion_price: "￥530.00",
                  suggestion_specifications: "100ml"
                },
                {
                  series_id: 4,
                  id: 0,
                  product_id: 4,
                  suggestion_img: "./static/LRimg/productsAll/14.jpg",
                  suggestion_title: "保湿滋养系列",
                  suggestion_mj: "保湿小分子水素喷雾",
                  suggestion_price: "￥597.00",
                  suggestion_specifications: "120ml"
                },
                {
                  series_id: 5,
                  id: 0,
                  product_id: 9,
                  suggestion_img: "./static/LRimg/productsAll/3.jpg",
                  suggestion_title: "活颜精华系列 ",
                  suggestion_mj: "3# 纯净精华液",
                  suggestion_price: "￥998.00",
                  suggestion_specifications: "40ml"
                },
                {
                  series_id: 5,
                  id: 1,
                  product_id: 10,
                  suggestion_img: "./static/LRimg/productsAll/4.jpg",
                  suggestion_title: "活颜精华系列 ",
                  suggestion_mj: "3-1# 活颜精华露",
                  suggestion_price: "￥798.00",
                  suggestion_specifications: "40ml"
                }
              ]
            }
          ]
        }
      ]
    },
    {
      series_id: 10,
      series_name: "隔离防护系列",
      isnull: "a",
      product_list: [
        //6#隔离精华乳
        {
          product_id: 19,
          product_img: "./static/LRimg/productsAll/10.jpg",
          product_title: "隔离防护系列 ",
          product_mj: "6# 隔离精华乳",
          product_price: "￥480.00",
          product_specifications: "50g",
          mj_school_poster: "./static/YTimg/videohead/6.jpg",
          mj_school_video: "http://video.anab.com.cn/12.mp4",
          pro_mj_detail: [
            {
              mj_school_head: "./static/YTimg/detailsV/6.jpg",
              product_mj: "6# 隔离精华乳",
              product_title: "隔离防护系列",
              pro_mj_Summary:
                "肌肤的防护衣，集隔离、保湿、防护三效合一的精华型隔离乳液。",
              product_price: "￥480.00",
              product_specifications: "50g",
              product_img: "./static/LRimg/productsAll/10.jpg",
              product_img2: "./static/LRimg/productsAll2/6.jpg",
              product_effect:
                "一款兼具美容效果的隔离防护产品，保护肌肤避免肌肤受到环境辐射、汽车尾气与空气污染等伤害。油脂吸附粉末，防汗防水，能长时间保持肌肤清爽，作为妆前乳使用能够长时间维持妆容细致，炎热季节使用也不会感到黏腻厚重。",
              product_explain:
                "保养工作后，化妆前使用，取一元硬币大小的量均匀涂抹于面部，轻轻拍打覆盖肌肤。",
              collocation_suggestion: [
                {
                  series_id: 3,
                  id: 0,
                  product_id: 2,
                  suggestion_img: "./static/LRimg/productsAll/1.jpg",
                  suggestion_title: "清洁系列 ",
                  suggestion_mj: "1# 柔和卸妆乳",
                  suggestion_price: "￥480.00",
                  suggestion_specifications: "150ml"
                },
                {
                  series_id: 4,
                  id: 3,
                  product_id: 5,
                  suggestion_img: "./static/LRimg/productsAll/3.jpg",
                  suggestion_title: "保湿滋养系列 ",
                  suggestion_mj: "4# 保湿整肤液",
                  suggestion_price: "￥530.00",
                  suggestion_specifications: "100ml"
                },
                {
                  series_id: 4,
                  id: 1,
                  product_id: 7,
                  suggestion_img: "./static/LRimg/productsAll/8.jpg",
                  suggestion_title: "保湿滋养系列 ",
                  suggestion_mj: "5# 活力保湿霜",
                  suggestion_price: "￥530.00",
                  suggestion_specifications: "50ml"
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};



// WEBPACK FOOTER //
// ./src/data/data.js